import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { setButtonBackToActive } from "@/store/tradeDataStoreACTIONS";
import {
  actionsConfigOP,
  actionsConfigRP,
  getEnumKeyByEnumValue,
} from "../actionButtonsHelper";

export const getActionsMainButton = (
  structureType: string,
  status: string,
  params: any,
) => {
  const keyToPass = getEnumKeyByEnumValue(
    // Reverse map the string back to the enum.
    ExecutionStrategyStatus,
    status,
  );

  // Early return to change the RP Exectued (Recoupen) actions:
  // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
  // if (
  //   params.node.data.role == "RP" &&
  //   keyToPass == "Executed" &&
  //   hasRecoupon(params)
  // ) {
  //   return [
  //     {
  //       id: "Recoupon",
  //       function: recouponTradeAction,
  //     },
  //   ];
  // }

  if (keyToPass && keyToPass != "New") {
    //
    return params.data.role == "OP"
      ? actionsConfigOP[structureType]?.[keyToPass] || [
          {
            id: "View Trade",
            function: () => {
              params.node.setExpanded(true);
              setButtonBackToActive(params.data.esid);
            },
          },
        ]
      : actionsConfigRP[structureType]?.[keyToPass] || [
          {
            id: "View Trade",
            function: () => {
              params.node.setExpanded(true);
              setButtonBackToActive(params.data.esid);
            },
          },
        ];
  } else if (status == "New") {
    return [
      {
        id: "Send to Panel", // Will be used to open a trade if it's closed. If open, this will attempt to send the trade.
        function: () => {
          params.node.setExpanded(true);
          setButtonBackToActive(params.data.esid);
        },
      },
    ];
  } else {
    return [
      {
        id: "View Trade",
        function: () => {
          params.node.setExpanded(true);
          setButtonBackToActive(params.data.esid);
        },
      },
    ];
  }
};
